import { Injectable } from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { getLocationOrigin } from '@libs/src/utilities/url.utilities';

import get from 'lodash-es/get';
import isFunction from 'lodash-es/isFunction';
import keys from 'lodash-es/keys';
import result from 'lodash-es/result';

declare let window: any;

@Injectable()
export class UserAnalyticsService {
  clearAnalytics() {
    result(window, 'analytics.reset');
    result(window, 'mixpanel.reset');
  }

  sendAnalyticsIdentify(account: Account) {
    const identifyProperties = {
      aboutComplete: !!account.about,
      createdAt: account.created_at,
      email: account.email,
      firstName: account.first_name,
      geo_location: account.geo_location,
      hasPhoto: !!account.portrait_original_url,
      jobTitle: get(account, 'experience[0].job_title'),
      lastName: account.last_name,
      name: account.full_name,
      organization: get(account, 'experience[0].organization_name'),
      shortBioComplete: !!account.short_bio,
      signupMethod: account.signup_method,
      slug: account.slug,
      status: account.status,
      tenantUrl: getLocationOrigin(),
    };
    const peopleProperties = {
      peopleProperties: keys(identifyProperties),
    };
    if (window.analytics && window.analytics.identify) {
      window.analytics.identify(account._id, identifyProperties, {
        Mixpanel: peopleProperties,
      });
    }
  }

  setAnalyticsAlias(account: Account) {
    if (!window.analytics) {
      return;
    }

    const analyticsAliasFunction = get(window, 'analytics.alias');
    const analyticsUserFunction = get(window, 'analytics.user');
    const anonymousId =
      isFunction(analyticsUserFunction) &&
      analyticsUserFunction().anonymousId();
    if (isFunction(analyticsAliasFunction) && anonymousId) {
      analyticsAliasFunction(account._id, anonymousId);
    }
  }
}
